import { render, staticRenderFns } from "./channelCofiiguration.vue?vue&type=template&id=62ca55c6&scoped=true&"
import script from "./channelCofiiguration.vue?vue&type=script&lang=js&"
export * from "./channelCofiiguration.vue?vue&type=script&lang=js&"
import style0 from "./channelCofiiguration.vue?vue&type=style&index=0&id=62ca55c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62ca55c6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VChip,VCombobox,VContainer,VFlex,VIcon,VLayout,VTextField})
